














import Vue, { PropType } from "vue";
import Star from "@/components/Atoms/Rates/Star/index.vue";
import Stars from "@/components/Molecules/Rates/Stars/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { Data, Methods, Computed, Props } from "./types";

const pixels = {
  small: 12,
  medium: 14,
  large: 20,
  exLarge: 24
};

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Rates",
  components: {
    Star,
    Stars,
    Heading
  },
  props: {
    size: {
      type: String as PropType<Props["size"]>,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large", "exLarge"].includes(value);
      }
    },
    rate: {
      type: Number as PropType<Props["rate"]>,
      default: 0,
      validator(value) {
        return 0 <= value && value <= 5;
      }
    },
    short: {
      type: Boolean as PropType<Props["short"]>,
      default: false
    },
    bold: {
      type: Boolean as PropType<Props["bold"]>,
      default: false
    }
  },
  computed: {
    ratingText() {
      return this.rate ? String(this.rate.toFixed(1)) : "-";
    },
    ratesClasses() {
      return ["rates", `rates--${this.size}`, { "rates--bold": this.bold }];
    },
    priority() {
      return ["large", "exLarge"].includes(this.size) ? "1" : "4";
    }
  },
  methods: {
    sizeToPixel() {
      return pixels[this.size];
    }
  }
});
